"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigate = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _useLinkState2 = _interopRequireDefault(require("@hooks/useLinkState"));

var _BaseLink = _interopRequireDefault(require("@components/BaseLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Link = function Link(props) {
  var _useLinkState = (0, _useLinkState2["default"])(props === null || props === void 0 ? void 0 : props.href),
      isCurrent = _useLinkState.isCurrent,
      isPartiallyCurrent = _useLinkState.isPartiallyCurrent;

  return /*#__PURE__*/_react["default"].createElement(_BaseLink["default"], _extends({}, props, {
    active: isCurrent || isPartiallyCurrent || props.active
  }));
};

var navigate = function navigate() {
  var _window;

  return (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && (_window = window).open.apply(_window, arguments);
};

exports.navigate = navigate;
var _default = Link;
exports["default"] = _default;